import {
  NoConfirmationDefaultNavigatorConfiguration,
  NoConfirmationPreQualifiedPatientNavigatorConfiguration
} from "../App/Compositions/NavigatorConfigurations";
import {
  noConfirmationCenterSelectableBookingStepConfigurations,
  screeningStepConfigurations
} from "../App/Compositions/StepConfigurations";
import { Flow } from "./IFlow";

const newPatientFlowName = "newPatient";

/** Legacy flow name alias. Routes users with cached "newPatient" sessions to the no-confirmation experience. */
class NewPatientFlow extends Flow {
  static readonly flowName = newPatientFlowName;

  constructor(isPatientPreQualified: boolean) {
    isPatientPreQualified
      ? super(
          newPatientFlowName,
          { ...noConfirmationCenterSelectableBookingStepConfigurations },
          NoConfirmationPreQualifiedPatientNavigatorConfiguration
        )
      : super(
          newPatientFlowName,
          { ...screeningStepConfigurations, ...noConfirmationCenterSelectableBookingStepConfigurations },
          NoConfirmationDefaultNavigatorConfiguration
        );
  }
}

export default NewPatientFlow;
